import React from 'react'
import { Button, useTheme, useMediaQuery } from '@material-ui/core'
import { Container } from './Container'
import { EarlyAccessRequest, EarlyAccessRequestStatus } from '../models'

interface Props {
    earlyAccessRequest: EarlyAccessRequest
    onHandleEarlyAccessRequest: (approve: boolean) => void
    style?: React.CSSProperties
}

export const EarlyAccessRequestTransitionButtons = (props: Props) => {
    const { earlyAccessRequest, onHandleEarlyAccessRequest, style } = props
    const theme = useTheme()

    return (
        <Container
            style={{
                justifyContent: 'flex-end',
                margin: theme.spacing(1),
                flexDirection: 'row',
                ...style,
            }}
        >
            {earlyAccessRequest.status === EarlyAccessRequestStatus.PENDING && (
                <Button
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                        onHandleEarlyAccessRequest(true)
                    }}
                    style={{
                        marginRight: theme.spacing(1),
                        width: 'auto',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        fontWeight: 'bold',
                        textTransform: 'none',
                        borderRadius: theme.shape.borderRadius,
                        boxShadow: theme.shadows[2],
                    }}
                >
                    Approve Early Access
                </Button>
            )}
            {earlyAccessRequest.status === EarlyAccessRequestStatus.PENDING && (
                <Button
                    color="secondary"
                    variant="contained"
                    onClick={(e) => {
                        onHandleEarlyAccessRequest(false)
                    }}
                    style={{
                        width: 'auto',
                        backgroundColor: theme.palette.secondary.main,
                        color: theme.palette.secondary.contrastText,
                        fontWeight: 'bold',
                        textTransform: 'none',
                        borderRadius: theme.shape.borderRadius,
                        boxShadow: theme.shadows[2],
                    }}
                >
                    Deny Early Access
                </Button>
            )}
            {earlyAccessRequest.status !== EarlyAccessRequestStatus.PENDING && (
                <Button
                    color="default"
                    variant="contained"
                    disabled={true}
                    style={{
                        width: '100%',
                        backgroundColor: theme.palette.grey[200],
                        color: theme.palette.grey[500],
                        fontWeight: 'bold',
                        textTransform: 'none',
                        borderRadius: theme.shape.borderRadius,
                        boxShadow: theme.shadows[1],
                        cursor: 'not-allowed',
                    }}
                >
                    {earlyAccessRequest.status ===
                    EarlyAccessRequestStatus.APPROVED
                        ? 'Early Access Approved'
                        : 'Early Access Denied'}
                </Button>
            )}
        </Container>
    )
}
